<output class="center spinner-border text-primary">
  <span class="visually-hidden">Authentication in progress...</span>
</output>
